import React from 'react'
import Headers from '../headers/Headers'
import Footers from '../footers/Footers'
import FooterCall from '../footers/FooterCall'

const WaterTMng = () => {
  return (
    <>
     <Headers/>
     <div>
        <h1>Water TreatMent Management</h1>
        </div> 
        <Footers/>
        <FooterCall/>
    </>
  )
}

export default WaterTMng
